import { ReactElement } from 'react'

import { ListUsuario } from '../../domain/usecases/ListUsuario'
import UserRepository from '../../infra/repositories/UserRepository'
import UsuariosVinculados from '../../pages/UsuariosVinculados'

export const UsuariosVinculadosFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const listUsuario = new ListUsuario(userRepository)

  return <UsuariosVinculados listUsuario={listUsuario} />
}
